import React, { useEffect, useState } from 'react';
import { Instagram, ArrowUpRight, Play } from 'lucide-react';
import { SectionLabel } from './About';
import { brand } from '../data/mock';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

const InstagramFeed = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await fetch(`${API}/instagram/feed?limit=9`);
        const data = await res.json();
        if (!alive) return;
        if (data && Array.isArray(data.media) && data.media.length > 0) {
          setItems(data.media);
        } else if (data && data.error) {
          setError(data.error);
        }
      } catch (e) {
        if (alive) setError(e.message);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  if (!loading && items.length === 0) {
    // silently hide the section if the feed is unavailable
    return null;
  }

  return (
    <section className="relative py-24 md:py-32">
      <div className="max-w-6xl mx-auto px-6">
        <SectionLabel>Instagram</SectionLabel>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-12 gap-10 items-end mb-12">
          <h2 className="md:col-span-8 font-display text-[40px] sm:text-[54px] md:text-[68px] leading-[1.05] text-cream">
            Siga a BRN no<br />
            <a
              href={brand.instagramUrl}
              target="_blank"
              rel="noreferrer"
              className="text-cream/55 hover:text-cream transition-colors underline-offset-8 hover:underline"
            >
              @{brand.instagram}
            </a>
          </h2>
          <div className="md:col-span-4 flex md:justify-end">
            <a
              href={brand.instagramUrl}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 rounded-full border border-cream/25 px-6 py-2.5 text-sm text-cream hover:bg-cream hover:text-[#0b0807] transition-colors"
            >
              <Instagram className="w-4 h-4" />
              Ver perfil
            </a>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
          {loading &&
            Array.from({ length: 6 }).map((_, i) => (
              <div key={i} className="aspect-square rounded-md bg-[#120e0c] animate-pulse" />
            ))}

          {!loading &&
            items.map((it) => (
              <a
                key={it.id}
                href={it.permalink}
                target="_blank"
                rel="noreferrer"
                className="group relative aspect-square overflow-hidden rounded-md bg-[#120e0c]"
              >
                <img
                  src={it.display_url}
                  alt={it.caption ? it.caption.slice(0, 80) : 'Instagram post'}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  loading="lazy"
                  referrerPolicy="no-referrer"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/45 transition-colors" />

                {it.media_type === 'VIDEO' && (
                  <div className="absolute top-3 right-3 w-8 h-8 rounded-full bg-black/50 backdrop-blur-sm flex items-center justify-center">
                    <Play className="w-3.5 h-3.5 text-white fill-white" />
                  </div>
                )}
                {it.media_type === 'CAROUSEL_ALBUM' && (
                  <div className="absolute top-3 right-3 w-8 h-8 rounded-full bg-black/50 backdrop-blur-sm flex items-center justify-center">
                    <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 text-white" fill="currentColor">
                      <path d="M7 3h11a3 3 0 0 1 3 3v11a1 1 0 1 1-2 0V6a1 1 0 0 0-1-1H7a1 1 0 1 1 0-2Zm-4 4h11a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1Zm1 2v11h10a1 1 0 0 0 1-1V9H4Z" />
                    </svg>
                  </div>
                )}

                <div className="absolute inset-x-0 bottom-0 p-3 flex items-end justify-between opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <p className="text-white text-[12px] line-clamp-2 max-w-[80%] drop-shadow">
                    {it.caption ? it.caption.slice(0, 90) : ''}
                  </p>
                  <ArrowUpRight className="w-5 h-5 text-white flex-shrink-0" />
                </div>
              </a>
            ))}
        </div>

        {error && (
          <p className="mt-6 text-cream/50 text-xs text-center">Não foi possível carregar o feed no momento.</p>
        )}
      </div>
    </section>
  );
};

export default InstagramFeed;
